import { render } from "./MaisInfos.vue?vue&type=template&id=0fe61285"
import script from "./MaisInfos.vue?vue&type=script&lang=js"
export * from "./MaisInfos.vue?vue&type=script&lang=js"

import "./MaisInfos.vue?vue&type=style&index=0&id=0fe61285&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__